import { useQuery } from '@tanstack/react-query';
import { getStoreAuditSummariesWithOverallTotals } from 'services/auditService';
import { StoreAuditSummariesResponse } from '../../types';

export function useStoreAuditSummaries(storeId: string | null | undefined, startDate: string | null | undefined, endDate: string | null | undefined) {

  return useQuery<StoreAuditSummariesResponse>({
    queryKey: ['store-audit-summaries', storeId, startDate, endDate],
    queryFn: () => getStoreAuditSummariesWithOverallTotals(storeId!, startDate!, endDate!),
    enabled: !!storeId && !!startDate && !!endDate
  });
}